// extracted by mini-css-extract-plugin
export default {"btnsComp":"learningZoneBtns_btnsComp__0q4uW","btnContainer":"learningZoneBtns_btnContainer__DoiN9","btnIcon":"learningZoneBtns_btnIcon__oJUkc"};